/**
 * 产品数据混入
 * 包含所有产品分类的数据
 */

// 先导入所有图片（在模块顶层，这样 require 能在编译时正确处理）
// 飞行平台图片

// 智能控制系统图片

import imgFKA2 from '@/assets/product/zdkxt/LANYVE-FKA2(FS)/LANYVE-FKA2(FS).png'
import imgIDKX3 from '@/assets/product/zdkxt/LANYVE-IDK-X3/LANYVE-IDK-X3.png'
import imgJINSA6 from '@/assets/product/zdkxt/LANYVE-JINSA6(FS)/LANYVE-JINSA6(FS).png'
import imgL900 from '@/assets/product/zdkxt/LANYVE-L900(FS)/LANYVE-L900(FS).png'
import imgJZA5 from '@/assets/product/zdkxt/LANYVE-JZA5/LANYVE-JZA5.png'
import img4GWIFI from '@/assets/product/zdkxt/LANYVE-4G-WIFI/LANYVE-4G-WIFI.png'
import imgIMU from '@/assets/product/zdkxt/LANYVE-FSROS-IMU/LANYVE-FSROS-IMU.png'
import imgDSA1 from '@/assets/product/zdkxt/LANYVE-DSA1/LANYVE-DSA1.png'
import imgMMWR  from '@/assets/product/hmbld/LANYVE-MMWR.png'
import imgMMW4D from '@/assets/product/hmbld/LANYVE-MMW4D.png'
import imgPC from '@/assets/product/kzpt/PCStation/bg2.png'
import imgAPP from '@/assets/product/kzpt/APPStation/bg2.png'
import imgMap from '@/assets/product/kzpt/APPStation/map1.png'

// 毫米波雷达图片

// 控制平台及软件图片




// 其他智能设备图片


export default {
    data() {
        return {
            // 飞行平台
            flightPlatform: [
                {
                    name: 'X15-多旋翼无人机',
                    code: "LANYVE-X15",
                    tab:'X15-多旋翼无人机',
                    desc: 'X15-多旋翼无人机',
                    title: '多旋翼无人机',
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/LANYVE-X15.png?x-oss-process=image/format,webp',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/bg.png?x-oss-process=image/format,webp', // 产品背景
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/det.png?x-oss-process=image/format,webp', // 参数配置背景
                    info: {
                        content: "LANYVE-X15四旋翼多用途无人机的应用场景非常广泛，可应用于警用，消防，医疗等行业。配合无人机机场+数据平台能实现“指点飞行、多目标管理、数据存储、AI识别”等多种功能。可应用于应急救援，高空巡逻，交通管理，森林巡检，森林消防，医疗配送等场景。",
                        images: [
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/info/big.png?x-oss-process=image/format,webp',
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/info/small.png?x-oss-process=image/format,webp'
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "18kg" },
                        { code: "max_speed", name: "最大飞行速度", value: "20m/s" },
                        { code: "max_load", name: "最大载荷", value: "3kg" },
                        { code: "max_wind", name: "最大抗风等级", value: "5级" },
                        { code: "max_time", name: "续航时间", value: "56min" }
                    ],
                    replacement: [
                        {
                            name: "降落伞",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "光电吊舱",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "喊话器",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/detail/3.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "无人化机库",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X15/detail/4.png?x-oss-process=image/format,webp'
                        }
                    ]
                },
                {
                    name: '垂直起降复合翼无人机', code: "LANYVE-FH100", desc: 'FH100-复合翼无人机', image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/LANYVE-FH100.png?x-oss-process=image/format,webp',
                    tab:'FH100-复合翼无人机',
                    title: '复合翼无人机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/bg.png?x-oss-process=image/format,webp',
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/det.png?x-oss-process=image/format,webp',
                    info: {
                        content: "LANYVE-FH100是一款垂直起降复合翼无人机，机体采用航空碳纤维复合材料，做到重量轻、强度高、防水、抗干扰。机体结构可拆卸分组，由机身、机翼、起落架、尾翼组成。机翼与机身设置快拆连接，不仅在结构方面满足强度和刚度要求，还满足拆卸方便、部署灵活、维护性强、模块化等要求。",
                        images: [
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/info/big.png?x-oss-process=image/format,webp'
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "100kg" },
                        { code: "max_speed", name: "最大飞行速度", value: "150km/h" },
                        { code: "max_load", name: "最大载荷", value: "45kg" },
                        { code: "features", name: "特点", value: "大载重、长续航、多负载" },
                        { code: "max_time", name: "续航时间", value: "挂载30kg@4h" }
                    ],
                    replacement: [
                        {
                            name: "多路抛投器",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "光电吊舱",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "检测设备",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/detail/3.png?x-oss-process=image/format,webp'
                        },
                    ],
                    features: [
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td1.png?x-oss-process=image/format,webp', name: '大范围巡查' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td2.png?x-oss-process=image/format,webp', name: '续航能力强' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td4.png?x-oss-process=image/format,webp', name: '远距离稳定操控' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td5.png?x-oss-process=image/format,webp', name: '清晰捕捉远距离目标的细节' },
                    ],
                    scene: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/scene/1.png?x-oss-process=image/format,webp',
                            name: '三维建模'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/scene/2.png?x-oss-process=image/format,webp',
                            name: '物资运输'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/scene/3.png?x-oss-process=image/format,webp',
                            name: '林业消防'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-FH100/scene/4.png?x-oss-process=image/format,webp',
                            name: '应急救援'
                        },
                    ]
                },
                {
                    name: '胜邪-电动共轴直升机', code: "LANYVE-GZ25", desc: '胜邪 GZ25-电动共轴无人机', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/LANYVE-GZ25.png?x-oss-process=image/format,webp',
                    tab:'胜邪 GZ25-电动共轴无人机',
                    title: '电动共轴无人机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/bg.png?x-oss-process=image/format,webp',
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/det.png?x-oss-process=image/format,webp',
                    info: {
                        content: "LANYVE-GZ25胜邪是一款模块化柱形电动共轴直升机，也叫干扰无人机，挂载雷达干扰设备完成任务干扰。无人机结构紧凑、可悬停作业、方便携带，满足常规起飞和弹射起飞能力。",
                        images: [
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/info/big.png?x-oss-process=image/format,webp',
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/info/small.png?x-oss-process=image/format,webp',
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "25kg" },
                        { code: "max_speed", name: "最大飞行速度", value: "72km/h" },
                        { code: "max_time", name: "续航时间", value: "20min" }
                    ],
                    replacement: [
                        {
                            name: "机载多合一模块",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "摄像吊舱",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "点云建模模块",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/detail/3.png?x-oss-process=image/format,webp'
                        },
                    ],
                    features: [
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td1.png?x-oss-process=image/format,webp', name: '模块化设计结构紧凑' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td10.png?x-oss-process=image/format,webp', name: '悬停作业适应多种作业环境' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td6.png?x-oss-process=image/format,webp', name: '机动灵活自主起飞' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td3.png?x-oss-process=image/format,webp', name: '干扰响应速度快干扰精度高' },
                    ],
                    scene: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/scene/1.png?x-oss-process=image/format,webp',
                            name: '地质探测'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/scene/2.png?x-oss-process=image/format,webp',
                            name: '能源巡检'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/scene/3.png?x-oss-process=image/format,webp',
                            name: '海事监管 '
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ25/scene/4.png?x-oss-process=image/format,webp',
                            name: '消防巡检'
                        },
                    ]
                },
                {
                    name: '小型四旋翼无人机', code: "LANYVE-X1", desc: 'X1-手抛式无人机', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/LANYVE-X1.png?x-oss-process=image/format,webp',
                    tab:'X1-手抛式无人机',
                    title: '手抛式无人机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/bg.png?x-oss-process=image/format,webp',
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/det.png?x-oss-process=image/format,webp',
                    info: {
                        content: "LANYVE-X1是一款专为单兵携行、快速响应的微型无人机系统，整机采用模块化设计，集智能导航，全自主作业、静默操作于一身，适用于单兵作战和反恐。",
                        images: [
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/info/big.png?x-oss-process=image/format,webp',
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/info/small.png?x-oss-process=image/format,webp',
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "970g" },
                        { code: "max_speed", name: "最大飞行速度", value: "22m/s" },
                        { code: "max_load", name: "最大载荷", value: "300g" },
                        { code: "features", name: "特点", value: "效率高" },
                        { code: "max_time", name: "续航时间", value: "20min" }
                    ],
                    replacement: [
                        {
                            name: "战斗部",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "光电吊舱",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "警示灯",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/detail/3.png?x-oss-process=image/format,webp'
                        },
                    ],
                    features: [
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td10.png?x-oss-process=image/format,webp', name: '起飞方式多样能适应高难度任务环境' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td8.png?x-oss-process=image/format,webp', name: '环境适应性强可在极端复杂环境下部署' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td6.png?x-oss-process=image/format,webp', name: '精准地定位与悬停获取数据更稳定' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td11.png?x-oss-process=image/format,webp', name: '智能避障与路径规划提升任务成功率' },
                    ],
                    scene: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/scene/1.png?x-oss-process=image/format,webp',
                            name: '目标监测'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/scene/2.png?x-oss-process=image/format,webp',
                            name: '自主导航'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X1/scene/3.png?x-oss-process=image/format,webp',
                            name: '飞行训练'
                        },

                    ]
                },
                {
                    name: '胜邪-共轴双旋翼无人机', code: "LANYVE-GZ500", desc: '胜邪 GZ500-共轴无人机', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/LANYVE-GZ500.png?x-oss-process=image/format,webp',
                    tab:'胜邪 GZ500-共轴无人机',
                    title: '共轴无人机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/bg.png?x-oss-process=image/format,webp',
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/det.png?x-oss-process=image/format,webp',
                    info: {
                        content: "LANYVE-GZ500是一款大载荷、长航时的工业级共轴无人直升机平台。它采用先进的共轴反桨旋翼设计，以200kg的有效载荷和60分钟的超长续航能力。搭载高性能进口动力系统，在复杂的自然环境与严苛的任务要求下，展现出卓越的稳定性与可靠性，是执行应急救援、物资运输及特种作业的空中主力。",
                        images: [
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/info/big.png?x-oss-process=image/format,webp',
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/info/small.png?x-oss-process=image/format,webp',
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "550kg" },
                        { code: "max_speed", name: "最大飞行速度", value: "120km/h" },
                        { code: "max_load", name: "最大载荷", value: "230kg" },
                        { code: "features", name: "特点", value: "大载重、长续航" },
                        { code: "max_time", name: "续航时间", value: "120min" }
                    ],
                    replacement: [
                        {
                            name: "武器装备",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "机载多合一模块",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "多路抛投器",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/detail/3.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "通信中继器",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/detail/4.png?x-oss-process=image/format,webp'
                        },
                    ],
                    features: [
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td10.png?x-oss-process=image/format,webp', name: '垂直起降，机动性强' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td12.png?x-oss-process=image/format,webp', name: '载重大长续航，多用途' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td11.png?x-oss-process=image/format,webp', name: '智能避障与路径规划提升任务成功率' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td13.png?x-oss-process=image/format,webp', name: '采用进口Rotax 915航空发动机， 提供强劲稳定的动力输出 ' },
                    ],
                    scene: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/scene/1.png?x-oss-process=image/format,webp',
                            name: '地质探测'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/scene/2.png?x-oss-process=image/format,webp',
                            name: '能源巡检'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/scene/3.png?x-oss-process=image/format,webp',
                            name: '林业消防 '
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-GZ500/scene/4.png?x-oss-process=image/format,webp',
                            name: '物流运输'
                        },
                    ]
                },
                {
                    name: '巨阙单旋翼直升机', code: "LANYVE-Z100", desc: '巨阙 Z100-单旋翼直升机', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/LANYVE-Z100.png?x-oss-process=image/format,webp',
                    tab:'巨阙 Z100-单旋翼直升机',
                    title: '单旋翼直升机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/bg.png?x-oss-process=image/format,webp',
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/det.png?x-oss-process=image/format,webp',
                    info: {
                        content: "LANYVE-Z100巨阙单旋翼直升机是一款工业级单旋翼无人直升机，具有体积小、载重大、续航长、抗风强和垂直起降特点，能适应林业、消防、巡检等复杂环境区作业任务。",
                        images: [
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/info/big.png?x-oss-process=image/format,webp',
                            'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/info/small.png?x-oss-process=image/format,webp',
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "110kg" },
                        { code: "max_speed", name: "最大飞行速度", value: "110km/h" },
                        { code: "max_load", name: "最大载荷", value: "50kg" },
                        { code: "features", name: "特点", value: "大载重、效率高" },
                        { code: "max_time", name: "续航时间", value: "60min" }
                    ],
                    replacement: [
                        {
                            name: "多路抛投器",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "医疗急救包",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "大重量物资",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/detail/3.png?x-oss-process=image/format,webp'
                        },
                    ],
                    features: [
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td13.png?x-oss-process=image/format,webp', name: '垂直起降，机动性强' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td7.png?x-oss-process=image/format,webp', name: '卓越的抗风性，无惧恶劣天气' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td10.png?x-oss-process=image/format,webp', name: '自主起降、精准悬停智能航线规划与一键返航' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td4.png?x-oss-process=image/format,webp', name: '自研控制系统，可自定义协议' },
                    ],
                    scene: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/scene/1.png?x-oss-process=image/format,webp',
                            name: '挂载实验'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/scene/2.png?x-oss-process=image/format,webp',
                            name: '能源巡检'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/scene/3.png?x-oss-process=image/format,webp',
                            name: '林业消防 '
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-Z100/scene/4.png?x-oss-process=image/format,webp',
                            name: '海事监管'
                        },
                    ]
                },
                // {
                //     name: '多旋翼无人机', code: "LANYVE-X115", desc: 'X115-多旋翼无人机', image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/LANYVE-X115.png',
                //     tab:'X115-多旋翼无人机',
                //     bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/bg.png',
                //     detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/det.png',
                //     info: {
                //         content: "LANYVE-X115多旋翼无人机，机型采用创新的结构设计与动力系统，在保持多旋翼无人机垂直起降、定点悬停等固有优势的同时，实现了长航时与大载重的性能突破，是面向行业应用场景推出的一款长航时大载重多功能飞行作业平台系统。",
                //         images: [
                //             'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/info/small.png',
                //             'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/info/big.png'
                //         ],
                //     },
                //     detail: [
                //         { code: "max_weight", name: "最大起飞重量", value: "115kg" },
                //         { code: "max_speed", name: "最大飞行速度", value: "22km/h" },
                //         { code: "max_load", name: "最大载荷", value: "50kg" },
                //         { code: "features", name: "特点", value: "大载重、效率高" },
                //         { code: "max_time", name: "续航时间", value: "27min" }
                //     ],
                //     replacement: [
                //         {
                //             name: "灭火弹",
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/detail/1.png'
                //         },
                //         {
                //             name: "水枪",
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/detail/2.png'
                //         },
                //         {
                //             name: "破窗器",
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/detail/3.png'
                //         },
                //     ],
                //     features: [
                //         { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td1.png', name: '垂直起降，机动性强' },
                //         { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td2.png', name: '卓越的抗风性，无惧恶劣天气' },
                //         { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td3.png', name: '自主起降、精准悬停智能航线规划与一键返航' },
                //         { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td4.png', name: '自研控制系统，可自定义协议' },
                //     ],
                //     scene: [
                //         {
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/scene/1.png',
                //             name: '应急消防'
                //         },
                //         {
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/scene/2.png',
                //             name: '物资运输'
                //         },
                //         {
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/scene/3.png',
                //             name: '林业消防'
                //         },
                //         {
                //             image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-X115/scene/4.png',
                //             name: '应急救援'
                //         },
                //     ]
                // },
                {
                    name: '自转旋翼机', code: "LANYVE-ZX650", desc: 'ZX650-自旋翼无人机', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/LANYVE-ZX650.png?x-oss-process=image/format,webp',
                    tab: 'ZX650-自旋翼无人机',
                    title: '自旋翼无人机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/bg.png?x-oss-process=image/format,webp',
                    detailBg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/det.png?x-oss-process=image/format,webp',
                    info: {
                        content: "LANYVE-ZX650自旋翼无人机，最大起飞重量可达650kg，是一款大载重无人机。通过利用推进螺旋桨提供动力，顶部旋翼桨提供升力，动力系统关闭能够安全着陆，是一款安全性能突出的轻型飞机。",
                        images: [
                           'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/info/big.png?x-oss-process=image/format,webp',
                           'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/info/small.png?x-oss-process=image/format,webp',
                            
                        ],
                    },
                    detail: [
                        { code: "max_weight", name: "最大起飞重量", value: "650kg" },
                        { code: "max_speed", name: "最大飞行速度", value: "150km/h" },
                        { code: "max_load", name: "最大载荷", value: "340kg" },
                        { code: "features", name: "特点", value: "大载重" },
                        { code: "max_time", name: "续航时间", value: "240min" }
                    ],
                    replacement: [
                        {
                            name: "多路抛投器",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/detail/1.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "光电吊舱",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/detail/2.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "检测设备",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/detail/3.png?x-oss-process=image/format,webp'
                        },
                        {
                            name: "大重量物资",
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/detail/4.png?x-oss-process=image/format,webp'
                        },
                    ],
                    features: [
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td6.png?x-oss-process=image/format,webp', name: '超短距起飞 起降要求低' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td7.png?x-oss-process=image/format,webp', name: '抗风性能高超低空飞行' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td8.png?x-oss-process=image/format,webp', name: '机动灵活环境适应能力强' },
                        { image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/td9.png?x-oss-process=image/format,webp', name: '安全性能高 失去动力安全迫降' },
                    ],
                    scene: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/scene/1.png?x-oss-process=image/format,webp',
                            name: '应急救援'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/scene/2.png?x-oss-process=image/format,webp',
                            name: '环境监测'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/scene/3.png?x-oss-process=image/format,webp',
                            name: '森林巡检'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/fxpt/LANYVE-ZX650/scene/4.png?x-oss-process=image/format,webp',
                            name: '物资运输'
                        },
                    ]
                }
            ],
            // 智能控制系统
            controlSystem: [
                {
                    name: '飞控计算机', code: "LANYVE-FKA2(FS)", desc: '飞控计算机', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FKA2%28FS%29.png?x-oss-process=image/format,webp',
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FKA2%28FS%29/LANYVE-FKA2%28FS%29.png?x-oss-process=image/format,webp',
                    image2: imgFKA2,
                    tab: '飞控计算机',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/bg.png?x-oss-process=image/format,webp',
                    info: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/info.png?x-oss-process=image/format,webp',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FKA2%28FS%29/det.png?x-oss-process=image/format,webp',
                    detailImg1:'',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FKA2%28FS%29/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "主控主频",
                            value: "180MHZ"
                        },
                        {
                            code: "memory",
                            name: "内存",
                            value: "32G"
                        },
                        {
                            code: "refresh_rate",
                            name: "数据刷新率",
                            value: "≥50HZ"
                        },
                        {
                            code: "RTK",
                            name: "RTK",
                            value: "≤5cm"
                        },
                    ]
                },
                {
                    name: '任务载荷计算机', code: "LANYVE-IDK-X3", desc: '任务载荷计算机', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-IDK-X3/LANYVE-IDK-X3.png?x-oss-process=image/format,webp',
                    image2: imgIDKX3,
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-IDK-X3.png?x-oss-process=image/format,webp',
                    tab: '任务载荷计算机',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-IDK-X3/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-IDK-X3/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "处理器",
                            value: "瑞芯微RK3588S"
                        },
                        {
                            code: "memory1",
                            name: "内存",
                            value: "8GB"
                        },
                        {
                            code: "refresh_rate",
                            name: "算力",
                            value: "6TOPS等效算力"
                        },
                        {
                            code: "RTK",
                            name: "主频",
                            value: "4核2.4GHz"
                        },
                    ]
                },
                {
                    name: '组合导航', code: "LANYVE-JINSA6(FS)", desc: '组合导航',
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JINSA6%28FS%29/LANYVE-JINSA6%28FS%29.png?x-oss-process=image/format,webp', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JINSA6%28FS%29.png?x-oss-process=image/format,webp',
                    image2: imgJINSA6,
                    tab: '组合导航',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JINSA6%28FS%29/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JINSA6%28FS%29/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "姿态精度",
                            value: "0.2°(RMS)"
                        },
                        {
                            code: "memory",
                            name: "速度精度",
                            value: "0.03m/s(RMS)"
                        },
                        {
                            code: "refresh_rate",
                            name: "陀螺仪量",
                            value: "±450°/s"
                        },
                        {
                            code: "RTK",
                            name: "加计量程",
                            value: "±16g"
                        },
                    ]
                },
                {
                    name: '机载数据链', code: "LANYVE-L900(FS)", desc: '机载数据链', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-L900%28FS%29/LANYVE-L900%28FS%29.png?x-oss-process=image/format,webp',
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-L900%28FS%29.png?x-oss-process=image/format,webp',
                    image2: imgL900,
                    tab: '机载数传电台',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-L900%28FS%29/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-L900%28FS%29/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "通信距离",
                            value: "20km"
                        },
                        {
                            code: "memory",
                            name: "载波频率",
                            value: "902-928MHz"
                        },
                        {
                            code: "refresh_rate",
                            name: "数据速率",
                            value: "230kbps"
                        },
                        {
                            code: "RTK",
                            name: "发射功率",
                            value: "1W"
                        },
                    ]
                },
                {
                    name: '地面站', code: "LANYVE-JZA5", desc: '地面站', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JZA5/LANYVE-JZA5.png?x-oss-process=image/format,webp', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JZA5.png?x-oss-process=image/format,webp',
                    image2: imgJZA5,
                    tab: '地面基站',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JZA5/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-JZA5/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "通信距离",
                            value: "20km"
                        },
                        {
                            code: "memory",
                            name: "载波频率",
                            value: "902-928MHz"
                        },
                        {
                            code: "refresh_rate",
                            name: "数据速率",
                            value: "230kbps"
                        },
                        {
                            code: "RTK",
                            name: "重量",
                            value: "260g"
                        },
                    ]
                },
                {
                    name: '4G-WIFI模块', code: "LANYVE-4G-WIFI", desc: '4G-WIFI模块', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-4G-WIFI/LANYVE-4G-WIFI.png?x-oss-process=image/format,webp', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-4G-WIFI.png?x-oss-process=image/format,webp',
                    image2: img4GWIFI,
                    tab: '4G模块',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-4G-WIFI/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-4G-WIFI/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "4G通信频段",
                            value: "全网通"
                        },
                        {
                            code: "memory",
                            name: "WiFi频率",
                            value: "2.4G"
                        },
                        {
                            code: "refresh_rate",
                            name: "数据速率",
                            value: "150Mbps"
                        },
                        {
                            code: "RTK",
                            name: "尺寸(mm)",
                            value: "76×58×20"
                        },
                    ]
                },
                {
                    name: 'IMU传感器', code: "LANYVE-FSROS-IMU", desc: 'IMU传感器', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FSROS-IMU/LANYVE-FSROS-IMU.png?x-oss-process=image/format,webp', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FSROS-IMU.png?x-oss-process=image/format,webp',
                    image2: imgIMU,
                    tab: 'IMU',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FSROS-IMU/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-FSROS-IMU/sub.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "姿态精度",
                            value: "0.2°(RMS)"
                        },
                        {
                            code: "memory",
                            name: "数据更新速率",
                            value: "最大500Hz"
                        },
                        {
                            code: "refresh_rate",
                            name: "重量",
                            value: "160g"
                        },
                        {
                            code: "RTK",
                            name: "尺寸(mm)",
                            value: "115×75×33"
                        },
                    ]
                },
                {
                    name: '调速模块', code: "LANYVE-DSA1", desc: '调速模块', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-DSA1/LANYVE-DSA1.png?x-oss-process=image/format,webp', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-DSA1.png?x-oss-process=image/format,webp',
                    image2: imgDSA1,
                    tab: '定速模块',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-DSA1/det.png?x-oss-process=image/format,webp',
                    sub: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/zdkxt/LANYVE-DSA1/sub.png?x-oss-process=image/format,webp',
                    detail: [   
                        {
                            code: "cpu",
                            name: "信号接口",
                            value: "Futaba接插件"
                        },
                        {
                            code: "memory",
                            name: "信号输入",
                            value: "转速和油门量"
                        },
                        {
                            code: "refresh_rate",
                            name: "重量",
                            value: "44g"
                        },
                        {
                            code: "RTK",
                            name: "尺寸(mm)",
                            value: "48×42×19"
                        },
                    ]
                }
            ],
            // 毫米波雷达
            radar: [
                { name: '避障雷达', code: "LANYVE-MMW4D", desc: '避障雷达', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMW4D.png?x-oss-process=image/format,webp/resize,w_1430/quality,Q_80', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMW4D/LANYVE-MMW4D.png?x-oss-process=image/format,webp/resize,w_1430/quality,Q_80',
                    image2: imgMMW4D,
                    tab: '避障雷达',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMW4D/det.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "调制方式",
                            value: "FMCW"
                        },
                        {
                            code: "memory",
                            name: "中心频率",
                            value: "80GHz"
                        },
                        {
                            code: "refresh_rate",
                            name: "探测范围",
                            value: "0.5-100m"
                        },
                        {
                            code: "RTK",
                            name: "数据周期",
                            value: "50ms"
                        },
                    ]
                 },
                { name: '测距雷达', code: "LANYVE-MMWR", desc: '测距雷达', 
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMWR.png?x-oss-process=image/format,webp', 
                    image1: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMWR/LANYVE-MMWR.png?x-oss-process=image/format,webp',
                    image2: imgMMWR,
                    tab: '测距雷达',
                    detailImg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/hmbld/LANYVE-MMWR/det.png?x-oss-process=image/format,webp',
                    detail: [
                        {
                            code: "cpu",
                            name: "调制方式",
                            value: "FMCW"
                        },
                        {
                            code: "memory",
                            name: "中心频率",
                            value: "80GHz"
                        },
                        {
                            code: "refresh_rate",
                            name: "探测范围",
                            value: "0.5-100m"
                        },
                        {
                            code: "RTK",
                            name: "数据周期",
                            value: "20ms"
                        },
                    ]
                 }
            ],
            // 控制平台及软件
            platformSoftware: [
                {
                    name: '无人机管控云平台',
                    code: "glypt",
                    desc: '支持蓝悦、大疆产品，支持机场管控',
                    title1: '智慧无人机管控云平台',
                    text:'智慧无人机管理系统是一种用于治安管理、应急消防、林业资源调查、自然保护区巡护等领域的无人机管控平台。',
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/glypt.png?x-oss-process=image/format,webp',
                    source:[
                        {img:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/1.png?x-oss-process=image/format,webp'},
                        {img:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/2.png?x-oss-process=image/format,webp'},
                        {img:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/3.png?x-oss-process=image/format,webp'},
                        {img:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/4.png?x-oss-process=image/format,webp'},
                        {img:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/5.png?x-oss-process=image/format,webp'}
                    ],
                    info: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/info.png?x-oss-process=image/format,webp',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/bg.png?x-oss-process=image/format,webp',
                    bg1:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/bg1.png?x-oss-process=image/format,webp',
                    bg2:'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/bg.png?x-oss-process=image/format,webp',
                    map: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/map.png?x-oss-process=image/format,webp',
                    carouseData:{
                        title: '无人机管控云平台',
                        titleDesc: '专业的无人机云端任务管控平台，具备多机场、多无人机的实时监控和远程控制能力，可实现无人机航线创建、任务管理、实时显示、远程遥控、飞行记录、数据管理、设备台账管理、组织管理等功能。',
                        bottomDesc: '生成用户专属的地图、航线库、任务库，在地图上展示任务的执行全过程和执行结果。',
                        list: [
                            {
                                image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/carousel/1.png?x-oss-process=image/format,webp',
                                name: '任务规划',
                                code: '1',
                                bottomDesc:'生成用户专属的地图、航线库、任务库，在地图上展示任务的执行全过程和执行结果。',
                            },
                            {
                                image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/carousel/2.png?x-oss-process=image/format,webp',
                                name: '虚拟座舱',
                                code: '2',
                                bottomDesc:'巡检无人化，简化操作步骤，自动执行高效、安全、可靠的飞行策略。'
                            },
                            {
                                image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/carousel/3.png?x-oss-process=image/format,webp',
                                name: '数据存储',
                                code: '3',
                                bottomDesc:'数据全面存储与分析，飞行过程中各类实时、离线数据在平台一点查看。'
                            },
                        ],
                    },
                    detail: [
                        {
                            code: "1",
                            title: "综合监管",
                            desc: "三维GIS为载体，形成管控一张图，自动化任务统一派发和全程跟踪",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/1/1.png?x-oss-process=image/format,webp',
                                    title: "规模化无人机态势掌控",
                                    desc: "使用三维 GIS 地图为载体，形成管控一张图，大屏可显示无人机地理空间位置信息，以及无人机在地理空间上的分布态势，无人机实时直播视频、无人机使用情况和总体数据等。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/1/2.png?x-oss-process=image/format,webp',
                                    title: "飞行任务",
                                    desc: "用于多机协同自动化任务的统一派发与全程跟踪，上级单位直接下发各类飞行任务（立即执行、定时任务），包括航线规划、电子围栏、以及展示任务的执行全过程和执行结果。"
                                },
                            ]
                        },
                        {
                            code: "2",
                            title: "数据存储与分析",
                            desc: "数据全面存储与分析，飞行过程中各类实时、离线数据在平台一点查看。",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/2/1.png?x-oss-process=image/format,webp',
                                    title: "图像、视频采集",
                                    desc: "影像数据都附带了详尽的数据信息，包括 AI 智能分析的结果、精确的经纬度坐标、拍摄时间戳，以及该架次无人机的责任人等关键信息。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/2/2.png?x-oss-process=image/format,webp',
                                    title: "全要素飞行记录及动态可视化",
                                    desc: "对飞行过程全要素数据保存，包括飞行轨迹，全程画面，飞行过程波形图，以及飞行中识别的问题地图点位，轨迹动画联动视频画面，实现飞行记录一比一还原"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/2/3.png?x-oss-process=image/format,webp',
                                    title: "直播大屏",
                                    desc: "单机和多机时展示直播画面，可根据在线机型进行选择展示，画面可分为单屏、双屏、四屏、九屏，单个画面可以全屏展示。"
                                },
                            ]
                        },
                        {
                            code: "3",
                            title: "预警智能上报及人工处置",
                            desc: "多种低空算法加持，预警实时上报，自动匹配处置人，大幅提升响应速度",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/3/1.png?x-oss-process=image/format,webp',
                                    title: "预警自动上报及人工初判",
                                    desc: "算法会对实时识别的预警进行上报，然后进行人工初判，包括处理误报、疑似重复上报、人工处置下发事件等"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/3/2.png?x-oss-process=image/format,webp',
                                    title: "人工现场处置上报",
                                    desc: "对确认问题的下发责任人，责任人现场处置，并记录信息上报，形成事件闭环。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/UAVControlPlatform/detail/3/3.png?x-oss-process=image/format,webp',
                                    title: "人工处置移动端",
                                    desc: "人工处置责任人通过移动端看到下发给自己的处置事件和详细信息，并通过移动端进行处置信息上报。"
                                }
                            ]
                        }
                    ]
                },
                //{ name: 'AI感知算法平台', code: "AI", desc: '无人机动态视觉下目标监测', image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/sfpt.png?x-oss-process=image/format,webp' },
                {
                    name: 'PC地面站软件',
                    code: "PC",
                    desc: '仿真飞行，多机控制',
                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/pcdmz.png?x-oss-process=image/format,webp',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/bg.png?x-oss-process=image/format,webp',
                    bg2: imgPC,
                    map: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/map.png?x-oss-process=image/format,webp',
                    map1: imgMap,
                    carouseData: {
                        title: '地面站PC',
                        titleDesc: '无人机系统的“移动大脑”，集成飞行控制、任务规划、实时数据接收等功能，实现作业现场快速部署、是实时操控无人机的关键软件。',
                        bottomDesc: '接收无人机实时飞行数据，下达无人机飞行控制指令，用户可以了解飞行状态，随时暂停、继续或紧急中断任务；',
                        list: [
                            {
                                image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/carousel/1.png?x-oss-process=image/format,webp',
                                name: '飞行界面',
                                code: '1',
                                bottomDesc: '接收无人机实时飞行数据，下达无人机飞行控制指令，用户可以了解飞行状态，随时暂停、继续或紧急中断任务；',
                            },
                            {
                                image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/carousel/2.png?x-oss-process=image/format,webp',
                                name: '设备管理',
                                code: '2',
                                bottomDesc: '一站多机，对各个设备状态、设备详情、历史数据进行管理，更好的了解设备运行状况',
                            },
                            {
                                image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/carousel/3.png?x-oss-process=image/format,webp',
                                name: '航线规划',
                                code: '3',
                                bottomDesc: '生成用户专属的地图、航线库，通过精密的航线规划，实现无人机任务自动化、智能化',
                            }
                        ],
                    },
                    detail: [
                        {
                            code: "1",
                            title: "飞行控制",
                            desc: "涵盖无人机飞行、云台、喊话器照明灯等控制指令，可用于空中指挥疏导、夜间照明等场景",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/1/1.png?x-oss-process=image/format,webp',
                                    title: "飞机操控",
                                    desc: "如自主起飞、自主降落、紧急返航、航线调整等一键式飞行操作，用户可以随时暂停、继续或紧急中断任务；"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/1/2.png?x-oss-process=image/format,webp',
                                    title: "负载控制",
                                    desc: "云台左右俯仰控制，云台红白光切换控制，喊话器照明灯控制，降落伞等负载控制。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/1/3.png?x-oss-process=image/format,webp',
                                    title: "飞控惯导参数调整",
                                    desc: "通过调整飞控和惯导参数来优化无人机的飞行性能、稳定性和操控手感。"
                                },
                            ]
                        },
                        {
                            code: "2",
                            title: "实时监测",
                            desc: "单个控制站可以同时指挥、控制和管理多架无人机，提升到多机协同、高效管理的体系化作业水平。",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/2/1.png?x-oss-process=image/format,webp',
                                    title: "通用化架构",
                                    desc: "通过软件定义和模块化设计，使地面站能适配不同的无人机通信协议和任务指令"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/2/2.png?x-oss-process=image/format,webp',
                                    title: "高效数据链",
                                    desc: "同时与多架无人机建立独立、稳定、抗干扰的通信链路，实现一个地面站同时形成多个波束，分别与不同无人机通信。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/2/3.png?x-oss-process=image/format,webp',
                                    title: "智能任务管理",
                                    desc: "能动态分配任务、规划冲突-free的航线，并处理突发情况。"
                                },
                            ]
                        },
                        {
                            code: "3",
                            title: "作业规划",
                            desc: "生成用户专属的地图、航线库，通过精密的航线规划，实现无人机任务自动化、智能化",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/3/1.png?x-oss-process=image/format,webp',
                                    title: "航线规划",
                                    desc: "在地图上手动添加多个航点来自定义飞行路径，飞机可沿着路径自动化执行任务和采集数据，支持保存任务方案。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/3/2.png?x-oss-process=image/format,webp',
                                    title: "航点参数设置",
                                    desc: "设置航点的飞行高度、飞行速度、机头朝向等飞行参数，支持航点参数批量编辑，包括航点的动作，如拍照、录像、悬停时间等参数"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/PCStation/detail/3/3.png?x-oss-process=image/format,webp',
                                    title: "作业区和禁飞区规划",
                                    desc: "可以在地图上手动绘制多边形、圆形、矩形等形状来划定任务区域，可以防止飞机飞出作业区或飞入禁飞区造成安全隐患。"
                                },
                            ]
                        }
                    ]
                },
                {
                    name: '移动地面站软件', code: "APP", desc: '远程控制安卓app', image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/yddmz.png?x-oss-process=image/format,webp',
                    bg: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/bg.png?x-oss-process=image/format,webp',
                    bg2:imgAPP,
                    map: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/map.png?x-oss-process=image/format,webp',
                    map1: imgMap,
                    carouseData:{
                        title: '地面站app',
                        titleDesc: '无人机系统的“移动大脑”，集成飞行控制、任务规划、实时数据接收等功能，实现作业现场快速部署、是实时操控无人机的关键软件。',
                        bottomDesc: '接收无人机实时飞行数据，下达无人机飞行控制指令，用户可以了解飞行状态，随时暂停、继续或紧急中断任务；',
                        list: [
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/carousel/1.png?x-oss-process=image/format,webp',
                            name: '飞行界面',
                            code: '1',
                            bottomDesc: '接收无人机实时飞行数据，下达无人机飞行控制指令，用户可以了解飞行状态，随时暂停、继续或紧急中断任务；'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/carousel/2.png?x-oss-process=image/format,webp',
                            name: '负载控制',
                            code: '2',
                            bottomDesc: '涵盖无人机飞行、云台、喊话器照明灯等控制指令，可用于空中指挥疏导、夜间照明等场景'
                        },
                        {
                            image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/carousel/3.png?x-oss-process=image/format,webp',
                            name: '航线规划',
                            code: '3',
                            bottomDesc: '生成用户专属的地图、航线库，通过精密的航线规划，实现无人机任务自动化、智能化'
                        },
                        ],
                    },
                    detail: [
                        {
                            code: "1",
                            title: "飞行控制",
                            desc: "涵盖无人机飞行、云台、喊话器照明灯等控制指令，可用于空中指挥疏导、夜间照明等场景",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/1/1.png?x-oss-process=image/format,webp',
                                    title: "飞机操控",
                                    desc: "如自主起飞、自主降落、紧急返航、航线调整等一键式飞行操作，用户可以随时暂停、继续或紧急中断任务；"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/1/2.png?x-oss-process=image/format,webp',
                                    title: "负载控制",
                                    desc: "云台左右俯仰控制，云台红白光切换控制，喊话器照明灯控制，降落伞等负载控制。"
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/1/3.png?x-oss-process=image/format,webp',
                                    title: "飞控惯导参数调整",
                                    desc: "通过调整飞控和惯导参数来优化无人机的飞行性能、稳定性和操控手感。"
                                },
                            ]
                        },
                        {
                            code: "2",
                            title: "飞行数据实时监测",
                            desc: "了解无人机自身状态，保证飞行安全与平台稳定",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/2/1.png?x-oss-process=image/format,webp',
                                    title: "实时接收无人机数据",
                                    desc: "实时显示无人机在飞行过程中的数据（位置、高度、姿态、航线进度、电池状态、实时画面等）；",
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/2/2.png?x-oss-process=image/format,webp',
                                    title: "动态避障、姿态仪",
                                    desc: "通过视觉、雷达等传感器实时感知并规避未预知的障碍物",
                                },
                            ]
                        },
                        {
                            code: "3",
                            title: "作业规划",
                            desc: "生成用户专属的地图、航线库，通过精密的航线规划，实现无人机任务自动化、智能化",
                            content: [
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/3/1.png?x-oss-process=image/format,webp',
                                    title: "航线规划",
                                    desc: "在地图上手动添加多个航点来自定义飞行路径，飞机可沿着路径自动化执行任务和采集数据，支持保存任务方案。",
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/3/2.png?x-oss-process=image/format,webp',
                                    title: "航点参数设置",
                                    desc: "设置航点的飞行高度、飞行速度、机头朝向等飞行参数，支持航点参数批量编辑，包括航点的动作，如拍照、录像、悬停时间等参数",
                                },
                                {
                                    image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/kzpt/APPStation/detail/3/3.png?x-oss-process=image/format,webp',
                                    title: "作业区和禁飞区规划",
                                    desc: "可以在地图上手动绘制多边形、圆形、矩形等形状来划定任务区域，可以防止飞机飞出作业区或飞入禁飞区造成安全隐患。",
                                },
                            ]
                        }
                    ]
                }
            ],
            // 其他智能设备
            // otherDevices: [
            //     { name: '无人车', code: "wrc", desc: 'web端，可私有化部署', image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/qtznsb/wrc.png' },
            //     { name: '机器人', code: "jqr", desc: 'Windows系统', image: 'https://lanyuegatewebsite.oss-cn-hangzhou.aliyuncs.com/lanyue-website/product/qtznsb/jqr.png' }
            // ]
        }
    }
}
